import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios, { AxiosHeaders } from 'axios';
import { toError, assertOk } from '@/services/normalize';
import { M_POST, CORE_URL, GET_USER_ONLINE } from '@/utils/api';
import type { ExtAxiosConfig } from '@/middleware/axios-ui';

@Module({ name: 'useronline' })
export default class UserOnline extends VuexModule {
  userOnline: any = [];

  @Mutation
  mutateUserOnline(userOnline: any) {
    this.userOnline = userOnline;
  }

  @Action({ commit: 'mutateUserOnline', rawError: true })
  async FetchPlayerOnline(payload: { language: string; cfg?: ExtAxiosConfig }) {
    try {
      const { language, cfg } = payload || ({} as any);

      const headers = AxiosHeaders.from({
        'Accept-Language': language
      });

      if ((cfg as any)?.__silentLoading) {
        headers.set('x-silent-loading', '1');
      }

      const { data } = await axios({
        url: CORE_URL + GET_USER_ONLINE,
        method: M_POST,
        data: {},
        ...(cfg || {}),
        headers
      });

      assertOk(data, 'Fetch player online failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch player online failed');
    }
  }
}
